import styled from 'styled-components/macro'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

export const SelfcareInfoBox = styled(Box)`
    width: 100%;
    background: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 9px;

    @media ${respondAbove.xl} {
        position: sticky;
        top: 24px;
        margin-bottom: 244px;
    }
`

export const SelfcareInfoList = styled(Box)`
    & > * {
        padding-left: 14px;
        position: relative;

        &::before {
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 50%;
            position: absolute;
            left: 0;
            top: 6px;
            background-color: ${({ theme }) => theme.colors.grayscale_900};
        }
    }
`
